import styled from 'styled-components';
import { Colors } from '../../styles/constants';

interface cartaoStatus {
  ativo: boolean;
}

export const CardDeck = styled.div`
  display: flex;
  > div {
    width: 20%;
  }
`;

export const Cartao = styled.div<cartaoStatus>`
  display: flex;
  justify-content: space-between;
  padding: 0.5rem;
  background-color: ${props => (props.ativo ? Colors.cinza : Colors.danger)};
  border-radius: 0.25rem;
  color: #fff;
  margin: 6px 0;

  > div {
    display: flex;

    &:last-child {
      padding-right: 20px;
      font-weight: bold;
      align-items: center;
      svg {
        margin-right: 8px;
      }
    }
  }

  h6 {
    display: flex;
    b {
      padding-top: 4px;
    }
  }

  p {
    margin-bottom: 4px;
  }

  img {
    width: 120px;
    border: 1px solid #dee2e6 !important;
    border-radius: 0.25rem;
    margin-right: 0.5rem;
  }
`;

export const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  margin-bottom: 10px;

  /* h1 {
    margin-bottom: 0;
    background-color: ${Colors.cinza};
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    padding: 0.4rem 0.5rem;
    font-size: 1rem;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
    color: #fff;
    display: flex;
    align-items: baseline;

    svg {
      margin-right: 4px;
    }
  } */

  h2 {
    margin-bottom: 0;
    background-color: ${Colors.cinza};
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    padding: 0.4rem 0.5rem;
    font-size: 1rem;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
    color: #fff;
    display: flex;
    align-items: baseline;
    justify-content: center;

    svg {
      margin-left: 20px;
    }
  }

  /* > div {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 114px;
    color: #6c757d;
    overflow-x: auto;
  } */

  & + div {
    margin-left: 14px;
  }

  table tr {
    height: 30px;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
  background-color: ${Colors.cinza};
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  padding: 0.4rem 0.5rem;
  font-size: 1rem;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  color: #fff;

  svg {
    margin-right: 4px;
  }

  > span {
    display: flex;
    align-items: center;
  }
`;

export const CardHeaderCenter = styled.div`
  width: 100%;
  margin-bottom: 0;
  background-color: ${Colors.cinza};
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  padding: 0.4rem 0.5rem;
  font-size: 1rem;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  color: #fff;
  text-align: center;

  button {
    float: right;
    margin-right: 2px;
  }
`;

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 100px;
  color: #6c757d;
  overflow-x: auto;
`;

export const ButtonImpressoes = styled.button`
  cursor: pointer;
  border: 0;
  background-color: transparent;
  color: #0069d9;
  /* width: 200px; */

  &:hover {
    color: #0062cc;
  }
  /* & + button {
    margin-left: 7px;
  } */
`;

export const ButtonAdd = styled.button`
  cursor: pointer;
  border: 0;
  background-color: transparent;
  padding: 0 6px;
  color: #fff;

  &:hover {
    color: #000;
  }
`;
